import szota from "../img/szota.png";
import kanye from "../img/kanye2.jpg";
import styled from "styled-components";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
const Paralax = styled.div`
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  perspective: 10px;
  color: #181823;
`;
const Header = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 95%;
  transform-style: preserve-3d;
  z-index: -1;
  & > h1 {
    font-size: 18vh;
    font-weight: bold;
    text-align: center;
    color: #f8ffe8;
    text-shadow: 0 0 1vh #000000;
  }
  @media screen and (max-width: 479px) {
    & > h1 {
      line-height: 1, 5;
      font-size: 7rem;
    }
    & > h1 > span {
      font-size: 4rem;
    }
  }
`;
const Text = styled.div`
  font-size: 1.7rem;
  padding: 5vh 10vw;
  color: #fff;
  text-align: justify;
  background-color: #2e1919;
  line-height: 1.5;

  & > h2 {
    text-align: center;
    font-size: 3.5rem;
  }

  & > ul > li {
    text-align: left;
  }

  @media screen and (max-width: 479px) {
    & > h2 {
      font-size: 2.2rem;
    }
  }
`;
const Przod = styled.img`
  position: absolute;
  object-fit: cover;
  z-index: -1;
  top: 10vh;
  transform: translateZ(-10px) scale(3.25);
`;
const Tyl = styled.img`
  position: absolute;
  object-fit: cover;
  z-index: -1;
  top: -40vh;
  transform: translateZ(-30px) scale(4.5);
  height: 100%;
  width: 100%;
`;
const Srodek = styled.img`
  position: absolute;
  width: 30vh;
  height: 30vh;
  z-index: -1;

  transform: translateZ(-26px) scale(4);
`;
const Ziel = styled.span`
  color: #96f196;
`;
const Ziele = styled.span`
  color: #96f196;
  transition: 300ms;
  width: 0vw;
  &:hover {
    height: auto;
    width: auto;
    padding: 3px;
    cursor: pointer;
    background-color: #fff;
    color: #283918;
  }
`;
export default function Who() {
  return (
    <Paralax
      as={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Header>
        <h1>
          Cześć<span>, jestem</span> Daniel
        </h1>
        <Srodek alt="idk" src={kanye} />
        <Przod alt="idk" src={szota} />
        <Tyl
          alt="idk"
          src={
            "https://tarnowskiegory.pl/wp-content/uploads/2018/08/Sztolnia-Czarnego-Pstr%C4%85ga-szyb-EWA-zdj.-Grzegorz-Rudnicki_-1600x1200.jpg"
          }
        />
      </Header>
      <Text>
        <h2>Odkąd tylko pamiętam zawsze lubiłem tworzyć</h2>
        <p>
          Od rysunków na ścianach, przez animacje w Pivocie, frag filmy z CS'a,
          aż do dzisiaj, gdzie robie strony, <Ziel>filmy i grafiki</Ziel> "za
          kase". Kiedyś byśmy to z kolegami nazwali sprzedawaniem się, ale czas
          "CSGO śmieszne momenty 2016 pt.12" się skończył. Trzeba być dorosłym i
          płacić podatki i za paliwo and shit.
        </p>
        <br></br>
        <h3>Posiadam pasje w wielu dziedzinach, a moje najlepsze strony to:</h3>
        <ul>
          <li>
            <Ziel>Montaż filmów</Ziel>(I na youtube, i na wesele)
          </li>
          <li>
            <Ziel>Tworzenie witryn/aplikacji internetowych</Ziel>
          </li>
          <li>
            <Ziel>Grafiki komputerowe</Ziel>
          </li>
        </ul>
        <br></br>
        <h3>
          <p>W tworzeniu stron odznaczam się wiedzą w obsłudze:</p>
        </h3>
        <ol>
          <li>
            <Ziel>H5</Ziel>,<Ziel>CSS</Ziel>,<Ziel>JS</Ziel>
          </li>
          <li>
            <Ziel style={{ color: "#F1CE96" }}>ReactJS</Ziel>
          </li>
          <li>
            <Ziel style={{ color: "#96ECF1" }}>Wordpress</Ziel>
          </li>
          <li>
            oraz możliwość <Ziel>nauki praktycznie wszystkiego</Ziel>
          </li>
        </ol>
        <br></br>
        <p>
          Możesz zobaczyć moje portfolio{" "}
          <Link to="/portfolio">
            <Ziele>tutaj</Ziele>
          </Link>
          .
        </p>
        <br></br>
        <br></br>
        <h3>
          Jeśli chodzi o montaż wideo to mam doświadczenie w takich programach
          jak:
        </h3>
        <ol>
          <li>
            <Ziel style={{ color: "#EC96F1" }}>Premiere Pro</Ziel>
          </li>
          <li>
            <Ziel style={{ color: "#BA96F1" }}>After Effects</Ziel>
          </li>
          <li>
            <Ziel style={{ color: "#96B0F1" }}>Sony Vegas</Ziel>
          </li>
          <li>
            <Ziel style={{ color: "#96F197" }}>Camtasia</Ziel>
          </li>
        </ol>
        <br></br>
        <p>
          Możesz sprawdzić mój kanał na youtube{" "}
          <a
            rel="noreferrer"
            target="_blank"
            href="https://www.youtube.com/@szootnik2061"
          >
            <Ziele>tutaj</Ziele>
          </a>
          .
        </p>
        <br></br>
        <br></br>
      </Text>
    </Paralax>
  );
}
